import { useState } from 'react';

import { FieldSelectMulti } from '@/components/looker/field-select-multi';

import { ChartType } from '../entities/chart-type';

type Option<V> = { label: string; value: V };

function optionFromChartType(chartType: ChartType): Option<ChartType> {
  return { label: chartType, value: chartType };
}

export type ChartTypesFilterProps = {
  value: ChartType[];
  onChange: (value: ChartType[]) => void;
};

const options: Option<ChartType>[] =
  Object.values(ChartType).map(optionFromChartType);

export function ChartTypesFilter({
  value: defaultValue,
  onChange,
}: ChartTypesFilterProps) {
  const [selectedValue, setSelectedValue] = useState<ChartType[] | undefined>(
    undefined,
  );

  function handleChange(newValue: string[] = []) {
    // INFO: as there is only ChartType value in options={}, we know we only have ChartType here
    setSelectedValue(newValue as ChartType[]);
  }

  function handlePersist() {
    if (!selectedValue) {
      return;
    }

    onChange(selectedValue);
    setSelectedValue(undefined);
  }

  const value = selectedValue ?? defaultValue;

  return (
    <FieldSelectMulti
      className="max-w-[250px]"
      label="Charts"
      values={value}
      options={options}
      onChange={handleChange}
      onClose={handlePersist}
      flex={2}
      autoResize={false}
    />
  );
}
